module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmIyY2U3N2Q0YjBiOGM0MzI2MmQ1YWQxYjdlYzIwNTMucG5nIjs="